import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  MxBrowserStorageService,
  MxIdentityService,
  MxStorageType,
} from '../services';

/**
 * Opcionális erőforrás (pl. egy bejelentés fotója): a 404 nem visz a „nem található” oldalra, hanem a hívóhoz jut.
 * HttpContext-ként adjuk meg, így nem megy ki fejlécként a szerverre.
 */
export const SZ_NO_NOT_FOUND_REDIRECT = new HttpContextToken<boolean>(() => false);

@Injectable()
export class MxServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private identityService: MxIdentityService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (error.error.errorCode === 'EXPIRED_TOKEN') {
            MxBrowserStorageService.set(
              MxStorageType.Local,
              error.error.errorCode,
              error.error
            );
          }
          this.identityService.logout(true);
          return throwError(() => error.error);
        } else if (error.status === 403) {
          this.router.navigate(['pages', 'access-denied']);
          return throwError(() => 'Navigate to access-denied');
        } else if (error.status === 404 && request.context.get(SZ_NO_NOT_FOUND_REDIRECT)) {
          return throwError(() => error);
        } else if (error.status === 404) {
          this.router.navigate(['pages', 'not-found']);
          return throwError(() => 'Navigate to not-found');
        } else if ([400, 401, 500].includes(error.status)) {
          return throwError(() => error);
        } else {
          // A nyilvános jogi oldalak (áruházi adatlapok hivatkoznak rájuk) API nélkül is olvashatók maradnak.
          // (window.location: az app-inicializáló hívásokkor a router még nem navigált)
          const publicPage = /^\/pages\/(adatvedelem|reszveteli-feltetelek)/.test(window.location.pathname);
          if (!publicPage) {
            this.router.navigate(['pages', 'error']);
          }
          return throwError(() => 'Navigate to error');
        }
      })
    );
  }
}
